import { createContext } from 'react';
export var InstantSearchSSRContext = /*#__PURE__*/createContext(null);
if (process.env.NODE_ENV === 'development') {
  InstantSearchSSRContext.displayName = 'InstantSearchSSR';
}